/**
 * Collection of alert errors
 */
export enum AdsAlertErrors {
  INVALID_ANIMATION_DIRECTION = 'Invalid animation direction',
  INVALID_ALERT_LEVEL = 'Invalid alert level',
  DELAY_SET_WITHOUT_ANIMATION = "Prop 'animationDelay' was set without 'animation'. Please set 'animation' for the delay to take effect",
}

/**
 * Interface for visibleChange handler
 */
export type VisibleChangeHandler = (evt: VisibleChangeEvent) => void;

/**
 * An interface for the 'visibleChange' event
 * @docs
 */
export interface VisibleChangeEvent {
  el: HTMLElement;
  visible: boolean;
}

/**
 * The alert animation directions
 * @example
 * ```
 * <ads-alert animation="up"></ads-alert>
 * <ads-alert animation="down"></ads-alert>
 * ```
 * @public
 */
export enum AlertAnimationDirections {
  UP = 'up',
  DOWN = 'down',
}

export type AlertAnimationDirectionUp = 'up';
export type AlertAnimationDirectionDown = 'down';

/**
 * Animation direction options
 */
export type AlertAnimationDirection = AlertAnimationDirectionUp | AlertAnimationDirectionDown;

/**
 * The alert levels
 * @example
 * ```
 * <ads-alert level="success"></ads-alert>
 * <ads-alert level="warning"></ads-alert>
 * <ads-alert level="danger"></ads-alert>
 * ```
 * @public
 */
export enum AlertLevels {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export type AlertLevelSuccess = 'success';
export type AlertLevelWarning = 'warning';
export type AlertLevelDanger = 'danger';

/**
 * Alert level options
 */
export type AlertLevel = AlertLevelSuccess | AlertLevelWarning | AlertLevelDanger;
